import React, { useEffect, useRef, useState } from "react";
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
  Link,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PageWrapper from "../PageWrapper";
import SubNavbar from "../../components/Navbar/SubNavbar";
import ButtonBlue from "../../components/Button/ButtonBlue";

import DPTask from "./DPTask";
import NewAssignmentList from "./NewAssignmentList";
import Detail from "./Detail";
import MyCourses from "./MyCourses";
import TeachingTask from "./TeachingTask";
import TeachingPreview from "./TeachingPreview";
import { ButtonCommonTopNew } from "../Theme";
const TeachingPages = () => {
  const { path } = useRouteMatch();
  const location = useLocation();
  const dispatch = useDispatch();

  return (
    <PageWrapper>
      <div className="cardBackgroundColor border20px shadow-md md:mt-4 md:mb-6  mt-1 mb-3">
        {location.pathname !== `${path}/new` &&
          !location.pathname.includes(`${path}/task`) &&
          !location.pathname.includes(`${path}/detail`) &&
          !location.pathname.includes(`${path}/edit`) &&
          !location.pathname.includes(`${path}/preview`) && (
            <SubNavbar
              menuLinks={[
                { title: "DP Task Lists", url: path, count: null },
                { title: "My Courses", url: `${path}/courses`, count: null },
              ]}
              aside={
                <Link to={`${path}/new`} className="nav-navigate">
                  {/* <ButtonBlue
                    textStyle={"hover:underline"}
                    title="+ NEW ASSIGNMENT"
                  /> */}
                  <ButtonCommonTopNew className="px-4 py-2 rounded-lg text-sm">
                    + New Assignment
                  </ButtonCommonTopNew>
                </Link>
              }
            />
          )}
        <Switch>
          <Route exact path={path} component={DPTask} />
          <Route path={`${path}/courses`} component={MyCourses} />
          <Route path={`${path}/new`} component={NewAssignmentList} />
          <Route path={`${path}/edit/:id`} component={NewAssignmentList} />
          <Route path={`${path}/detail/:id`} component={Detail} />
          <Route path={`${path}/task/:id`} component={TeachingTask} />
          <Route path={`${path}/preview`} component={TeachingPreview} />
          {/* <Route path={`${path}/course`} component={Course} /> */}

          <Redirect
            to={{
              pathname: "/page-not-found",
              state: { error: true },
            }}
          />
        </Switch>
      </div>
    </PageWrapper>
  );
};

export default TeachingPages;
